(function () {
    'use strict';

    angular
        .module('ib-web-ancillaries-module')
        .factory('AncillariesTransformerService', AncillariesTransformerService);

    AncillariesTransformerService.$inject = ['AncillariesTransformer'];
    function AncillariesTransformerService (AncillariesTransformer) {
        const service = {
            generateAncillariesCheckin: generateAncillariesCheckin,
            generateAncillariesBooking: generateAncillariesBooking,
            generateAncillariesManageMyBooking: generateAncillariesManageMyBooking
        };

        return service;


        ////////////////

        /**
         * Return data structure of ancillaries for booking flow
         * @param {Object} ancillariesInfo  Ancillaries info
         * @param {Object} bookingInfo Booking info
         */
        function generateAncillariesCheckin (ancillariesInfo, bookingInfo) {
            const transformedData = AncillariesTransformers.generateInfoCommon(ancillariesInfo, bookingInfo);
            const transformedExtended = AncillariesTransformer.transformAncillariesView(transformedData, ancillariesInfo, bookingInfo);
            return transformedExtended;
        }

        /**
         * Return data structure of ancillaries for booking flow
         * @param {*} ancillariesInfo  Ancillaries info
         * @param {*} bookingInfo Booking info
         */
        function generateAncillariesBooking (ancillariesInfo, bookingInfo) {
            const transformedExtended = AncillariesTransformer.transformAncillariesView(transformedData, ancillariesInfo, bookingInfo);
            return transformedExtended;
        }

        /**
         * Return data structure of ancillaries for manage my booking flow
         * @param {Object} ancillariesInfo Ancillaries info
         * @param {Object} bookingInfo Booking info
         */
        function generateAncillariesManageMyBooking (ancillariesInfo, bookingInfo) {
            const transformedData = AncillariesTransformer.generateInfoManageMyBooking(ancillariesInfo, bookingInfo);
            return transformedData;
        }
    }
})();
